import { AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import {
  ContainerWrapper,
  LayoutContainer,
  LayoutWrapper,
} from "../../style/lauout/layout";
import NavMenu from "./nav";
import { useAutoLogout } from "../../hooks/useAutoLogout";
import { useAuthStore } from "../../atoms/user.auth.store";
import ModalCenterLayout from "../modal/modal.center.layout";
import AlertModal from "./modal/alert.modal";

interface ModalProps {
  isOpen: boolean;
  isVisible: boolean;
}

const Layout = () => {
  const location = useLocation(); // 현재 경로 가져오기
  const navigate = useNavigate();
  const { logout } = useAuthStore(); // ✅ 이 이름이 맞습니다

  const [timeoutModal, setTimeoutModal] = useState<ModalProps>({
    isOpen: false,
    isVisible: false,
  });

  useEffect(() => {
    // 페이지 이동 시 스크롤을 맨 위로 이동
    window.scrollTo(0, 0);
  }, [location.pathname]); // 경로 변경될 때 실행

  useAutoLogout(() => {
    setTimeoutModal({ isOpen: true, isVisible: true });
  });

  const timeoutModalClosed = () => {
    setTimeoutModal({ isOpen: false, isVisible: false });
    logout(); // ✅ 상태 초기화 + localStorage 정리
    navigate("/login");
  };

  return (
    <LayoutContainer>
      {/* <Header /> */}
      <AnimatePresence mode="wait" initial={true}>
        <ContainerWrapper>
          <NavMenu />
          <LayoutWrapper
            key={location.pathname} // 경로가 변경될 때마다 애니메이션 트리거
            initial={{ opacity: 0, y: 20 }} // 초기 상태 (살짝 오른쪽에서 시작)
            animate={{ opacity: 1, y: 0 }} // 나타날 때
            exit={{ opacity: 0, y: -20 }} // 사라질 때 (왼쪽으로 이동하며 사라짐)
            transition={{ duration: 0.3 }} // 애니메이션 속도
          >
            <Outlet />

            {/* {timeoutModal.isOpen && ( */}
            {timeoutModal.isOpen && (
              <ModalCenterLayout
                isVisible={timeoutModal.isVisible}
                closedHandler={timeoutModalClosed}
                size="s"
              >
                <AlertModal
                  closedHandler={timeoutModalClosed}
                  txt={`⏳ 일정 시간 동안 활동이 없어 \n자동 로그아웃되었습니다.`}
                />
              </ModalCenterLayout>
            )}
          </LayoutWrapper>
        </ContainerWrapper>
      </AnimatePresence>
    </LayoutContainer>
  );
};

export default Layout;
